import script from "./FeatureMosaicCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeatureMosaicCard.vue?vue&type=script&setup=true&lang=ts"

import "./FeatureMosaicCard.vue?vue&type=style&index=0&id=a70fc5cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a70fc5cc"]])

export default __exports__